import { WizardShell } from '../components/wizard/WizardShell.js';

export function WizardPage() {
  return <WizardShell />;
}
